export default __webpack_public_path__ + "static/media/load.c4cee91c.gif";